<nav class="navbar navbar-expand-md navbar-dark sticky-top bg-dark">
  <a class="navbar-brand" href="#">Tourlander</a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarsExampleDefault"
    aria-controls="navbarsExampleDefault" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarsExampleDefault">
    <ul class="navbar-nav mr-auto">
      <li class="nav-item active">
        <a class="nav-link" href="#">Inicio <span class="sr-only">(current)</span></a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLink="/tours">Tours</a>
      </li>
      <ng-container *ngIf="(afAuth.user | async) && (userData != null && userData.profile==profileTypes.Creador)">
        <li class="nav-item">
          <a class="nav-link" routerLink="/crear">Crear tour</a>
        </li>
      </ng-container>
    </ul>

    <ng-container *ngIf="afAuth.user | async as user; else login">
      <ul class="navbar-nav ml-auto nav-flex-icons">
        <!-- <li class="nav-item active">
          <a class="nav-link" routerLink="/crear">Crear tour</a>
        </li> -->
        <li class="nav-item avatar dropdown">
          <a class="nav-link dropdown-toggle" id="navbarDropdownMenuLink-55" data-toggle="dropdown" aria-haspopup="true"
            aria-expanded="false">
            <img *ngIf="userImageUrlSanitizer==null" src="http://ssl.gstatic.com/accounts/ui/avatar_2x.png"
              class="rounded-circle z-depth-0" alt="avatar image" height="40px" width="40px" style="object-fit: cover">
            <img *ngIf="userImageUrlSanitizer!=null" [src]="userImageUrlSanitizer" class="rounded-circle z-depth-0"
              alt="avatar image" height="40px" width="40px" style="object-fit: cover">
          </a>
          <div class="dropdown-menu dropdown-menu-lg-right dropdown-secondary"
            aria-labelledby="navbarDropdownMenuLink-55">
            <a class="dropdown-item" routerLink="/perfil">Mi cuenta</a>
            <a class="dropdown-item" (click)="auth.logout()">Cerrar sesión</a>
          </div>
        </li>
      </ul>
    </ng-container>


    <ng-template #login>
      <ul class="navbar-nav ml-auto nav-flex-icons">
        <li class="nav-item">
          <!-- <a class="nav-link" data-toggle="modal" data-target="#loginModal">Login</a> -->
          <a class="nav-link" (click)="eventEmitterService.onShowLoginModal(true)">Iniciar sesión</a>
        </li>
      </ul>
    </ng-template>

    <!-- <form class="form-inline my-2 my-lg-0">
      <input class="form-control mr-sm-2" type="text" placeholder="Search" aria-label="Search">
      <button class="btn btn-outline-success my-2 my-sm-0" type="submit">Search</button>
    </form> -->
  </div>
</nav>